import {
    DependenciesPayload,
    RadioInformationModel,
} from '@sxm-de/dev-kits/web-sdk/types';
import { logErrorFromMicroservicesSdk } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getRadioInformationForRadioIdSms(
    { radioId }: { radioId: string },
    dependencies: DependenciesPayload,
): Promise<RadioInformationModel> {
    const { microservicesSdk } = dependencies;
    try {
        const radio = await microservicesSdk.domains.device.validate({
            radioId,
        });
        return await microservicesSdk.domains.device.info({
            radioId: radio.last4DigitsOfRadioId,
        });
    } catch (error: any) {
        logErrorFromMicroservicesSdk(error, dependencies);
        throw new Error('SYSTEM');
    }
}
